export enum LANGUAGES {
    GERMANY_GERMAN = 'de-de',
    SWISS_GERMAN = 'de-ch',
    ENGLISH = 'en-us',
    SWISS_FRENCH = 'fr-ch',
    SWISS_ITALIAN = 'it-ch',
}
